import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
import trashRestorations from './trash-restorations'
import trashedWorks from './trashed-works'
import tags from './tags'
import sourceFacts from './source-facts'
import activity from './activity'
import dimensions from './dimensions'
import fieldConfirmations from './field-confirmations'
import parts from './parts'
import exhibitions from './exhibitions'
import valuations from './valuations'
import images from './images'
import documents from './documents'
/**
* @see \App\Http\Controllers\Works\TrashController::trash
* @see app/Http/Controllers/Works/TrashController.php:26
* @route '/works/trash'
*/
export const trash = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: trash.url(options),
    method: 'get',
})

trash.definition = {
    methods: ["get","head"],
    url: '/works/trash',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Works\TrashController::trash
* @see app/Http/Controllers/Works/TrashController.php:26
* @route '/works/trash'
*/
trash.url = (options?: RouteQueryOptions) => {
    return trash.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\TrashController::trash
* @see app/Http/Controllers/Works/TrashController.php:26
* @route '/works/trash'
*/
trash.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: trash.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\TrashController::trash
* @see app/Http/Controllers/Works/TrashController.php:26
* @route '/works/trash'
*/
trash.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: trash.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Works\TrashController::trash
* @see app/Http/Controllers/Works/TrashController.php:26
* @route '/works/trash'
*/
const trashForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: trash.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\TrashController::trash
* @see app/Http/Controllers/Works/TrashController.php:26
* @route '/works/trash'
*/
trashForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: trash.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\TrashController::trash
* @see app/Http/Controllers/Works/TrashController.php:26
* @route '/works/trash'
*/
trashForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: trash.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

trash.form = trashForm

/**
* @see \App\Http\Controllers\Works\BulkTrashWorksController::__invoke
* @see app/Http/Controllers/Works/BulkTrashWorksController.php:19
* @route '/works'
*/
export const bulkTrash = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: bulkTrash.url(options),
    method: 'delete',
})

bulkTrash.definition = {
    methods: ["delete"],
    url: '/works',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Works\BulkTrashWorksController::__invoke
* @see app/Http/Controllers/Works/BulkTrashWorksController.php:19
* @route '/works'
*/
bulkTrash.url = (options?: RouteQueryOptions) => {
    return bulkTrash.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\BulkTrashWorksController::__invoke
* @see app/Http/Controllers/Works/BulkTrashWorksController.php:19
* @route '/works'
*/
bulkTrash.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: bulkTrash.url(options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Works\BulkTrashWorksController::__invoke
* @see app/Http/Controllers/Works/BulkTrashWorksController.php:19
* @route '/works'
*/
const bulkTrashForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkTrash.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\BulkTrashWorksController::__invoke
* @see app/Http/Controllers/Works/BulkTrashWorksController.php:19
* @route '/works'
*/
bulkTrashForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkTrash.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

bulkTrash.form = bulkTrashForm

/**
* @see \App\Http\Controllers\Works\BulkTagWorksController::__invoke
* @see app/Http/Controllers/Works/BulkTagWorksController.php:19
* @route '/works/tags'
*/
export const bulkTags = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkTags.url(options),
    method: 'post',
})

bulkTags.definition = {
    methods: ["post"],
    url: '/works/tags',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Works\BulkTagWorksController::__invoke
* @see app/Http/Controllers/Works/BulkTagWorksController.php:19
* @route '/works/tags'
*/
bulkTags.url = (options?: RouteQueryOptions) => {
    return bulkTags.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\BulkTagWorksController::__invoke
* @see app/Http/Controllers/Works/BulkTagWorksController.php:19
* @route '/works/tags'
*/
bulkTags.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkTags.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\BulkTagWorksController::__invoke
* @see app/Http/Controllers/Works/BulkTagWorksController.php:19
* @route '/works/tags'
*/
const bulkTagsForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkTags.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\BulkTagWorksController::__invoke
* @see app/Http/Controllers/Works/BulkTagWorksController.php:19
* @route '/works/tags'
*/
bulkTagsForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkTags.url(options),
    method: 'post',
})

bulkTags.form = bulkTagsForm

/**
* @see \App\Http\Controllers\Works\BulkUntagWorksController::__invoke
* @see app/Http/Controllers/Works/BulkUntagWorksController.php:19
* @route '/works/tags'
*/
export const bulkUntag = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: bulkUntag.url(options),
    method: 'delete',
})

bulkUntag.definition = {
    methods: ["delete"],
    url: '/works/tags',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Works\BulkUntagWorksController::__invoke
* @see app/Http/Controllers/Works/BulkUntagWorksController.php:19
* @route '/works/tags'
*/
bulkUntag.url = (options?: RouteQueryOptions) => {
    return bulkUntag.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\BulkUntagWorksController::__invoke
* @see app/Http/Controllers/Works/BulkUntagWorksController.php:19
* @route '/works/tags'
*/
bulkUntag.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: bulkUntag.url(options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Works\BulkUntagWorksController::__invoke
* @see app/Http/Controllers/Works/BulkUntagWorksController.php:19
* @route '/works/tags'
*/
const bulkUntagForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkUntag.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\BulkUntagWorksController::__invoke
* @see app/Http/Controllers/Works/BulkUntagWorksController.php:19
* @route '/works/tags'
*/
bulkUntagForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkUntag.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

bulkUntag.form = bulkUntagForm

/**
* @see \App\Http\Controllers\Works\WorkController::autosave
* @see app/Http/Controllers/Works/WorkController.php:160
* @route '/works/{work}/autosave'
*/
export const autosave = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: autosave.url(args, options),
    method: 'put',
})

autosave.definition = {
    methods: ["put"],
    url: '/works/{work}/autosave',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Works\WorkController::autosave
* @see app/Http/Controllers/Works/WorkController.php:160
* @route '/works/{work}/autosave'
*/
autosave.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return autosave.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\WorkController::autosave
* @see app/Http/Controllers/Works/WorkController.php:160
* @route '/works/{work}/autosave'
*/
autosave.put = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: autosave.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Works\WorkController::autosave
* @see app/Http/Controllers/Works/WorkController.php:160
* @route '/works/{work}/autosave'
*/
const autosaveForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autosave.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\WorkController::autosave
* @see app/Http/Controllers/Works/WorkController.php:160
* @route '/works/{work}/autosave'
*/
autosaveForm.put = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autosave.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

autosave.form = autosaveForm

/**
* @see \App\Http\Controllers\Works\WorkController::index
* @see app/Http/Controllers/Works/WorkController.php:57
* @route '/works'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/works',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Works\WorkController::index
* @see app/Http/Controllers/Works/WorkController.php:57
* @route '/works'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\WorkController::index
* @see app/Http/Controllers/Works/WorkController.php:57
* @route '/works'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkController::index
* @see app/Http/Controllers/Works/WorkController.php:57
* @route '/works'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Works\WorkController::index
* @see app/Http/Controllers/Works/WorkController.php:57
* @route '/works'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkController::index
* @see app/Http/Controllers/Works/WorkController.php:57
* @route '/works'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkController::index
* @see app/Http/Controllers/Works/WorkController.php:57
* @route '/works'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Works\WorkController::store
* @see app/Http/Controllers/Works/WorkController.php:98
* @route '/works'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/works',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Works\WorkController::store
* @see app/Http/Controllers/Works/WorkController.php:98
* @route '/works'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\WorkController::store
* @see app/Http/Controllers/Works/WorkController.php:98
* @route '/works'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\WorkController::store
* @see app/Http/Controllers/Works/WorkController.php:98
* @route '/works'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\WorkController::store
* @see app/Http/Controllers/Works/WorkController.php:98
* @route '/works'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Works\WorkController::show
* @see app/Http/Controllers/Works/WorkController.php:117
* @route '/works/{work}'
*/
export const show = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/works/{work}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Works\WorkController::show
* @see app/Http/Controllers/Works/WorkController.php:117
* @route '/works/{work}'
*/
show.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return show.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\WorkController::show
* @see app/Http/Controllers/Works/WorkController.php:117
* @route '/works/{work}'
*/
show.get = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkController::show
* @see app/Http/Controllers/Works/WorkController.php:117
* @route '/works/{work}'
*/
show.head = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Works\WorkController::show
* @see app/Http/Controllers/Works/WorkController.php:117
* @route '/works/{work}'
*/
const showForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkController::show
* @see app/Http/Controllers/Works/WorkController.php:117
* @route '/works/{work}'
*/
showForm.get = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkController::show
* @see app/Http/Controllers/Works/WorkController.php:117
* @route '/works/{work}'
*/
showForm.head = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Works\WorkController::edit
* @see app/Http/Controllers/Works/WorkController.php:143
* @route '/works/{work}/edit'
*/
export const edit = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/works/{work}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Works\WorkController::edit
* @see app/Http/Controllers/Works/WorkController.php:143
* @route '/works/{work}/edit'
*/
edit.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return edit.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\WorkController::edit
* @see app/Http/Controllers/Works/WorkController.php:143
* @route '/works/{work}/edit'
*/
edit.get = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkController::edit
* @see app/Http/Controllers/Works/WorkController.php:143
* @route '/works/{work}/edit'
*/
edit.head = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Works\WorkController::edit
* @see app/Http/Controllers/Works/WorkController.php:143
* @route '/works/{work}/edit'
*/
const editForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkController::edit
* @see app/Http/Controllers/Works/WorkController.php:143
* @route '/works/{work}/edit'
*/
editForm.get = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkController::edit
* @see app/Http/Controllers/Works/WorkController.php:143
* @route '/works/{work}/edit'
*/
editForm.head = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Works\WorkController::update
* @see app/Http/Controllers/Works/WorkController.php:148
* @route '/works/{work}'
*/
export const update = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '/works/{work}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Works\WorkController::update
* @see app/Http/Controllers/Works/WorkController.php:148
* @route '/works/{work}'
*/
update.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return update.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\WorkController::update
* @see app/Http/Controllers/Works/WorkController.php:148
* @route '/works/{work}'
*/
update.put = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Works\WorkController::update
* @see app/Http/Controllers/Works/WorkController.php:148
* @route '/works/{work}'
*/
update.patch = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Works\WorkController::update
* @see app/Http/Controllers/Works/WorkController.php:148
* @route '/works/{work}'
*/
const updateForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\WorkController::update
* @see app/Http/Controllers/Works/WorkController.php:148
* @route '/works/{work}'
*/
updateForm.put = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\WorkController::update
* @see app/Http/Controllers/Works/WorkController.php:148
* @route '/works/{work}'
*/
updateForm.patch = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Works\WorkController::destroy
* @see app/Http/Controllers/Works/WorkController.php:170
* @route '/works/{work}'
*/
export const destroy = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/works/{work}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Works\WorkController::destroy
* @see app/Http/Controllers/Works/WorkController.php:170
* @route '/works/{work}'
*/
destroy.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return destroy.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\WorkController::destroy
* @see app/Http/Controllers/Works/WorkController.php:170
* @route '/works/{work}'
*/
destroy.delete = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Works\WorkController::destroy
* @see app/Http/Controllers/Works/WorkController.php:170
* @route '/works/{work}'
*/
const destroyForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\WorkController::destroy
* @see app/Http/Controllers/Works/WorkController.php:170
* @route '/works/{work}'
*/
destroyForm.delete = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const works = {
    trash: Object.assign(trash, trash),
    trashRestorations: Object.assign(trashRestorations, trashRestorations),
    trashedWorks: Object.assign(trashedWorks, trashedWorks),
    bulkTrash: Object.assign(bulkTrash, bulkTrash),
    bulkTags: Object.assign(bulkTags, bulkTags),
    bulkUntag: Object.assign(bulkUntag, bulkUntag),
    tags: Object.assign(tags, tags),
    sourceFacts: Object.assign(sourceFacts, sourceFacts),
    activity: Object.assign(activity, activity),
    dimensions: Object.assign(dimensions, dimensions),
    fieldConfirmations: Object.assign(fieldConfirmations, fieldConfirmations),
    autosave: Object.assign(autosave, autosave),
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    parts: Object.assign(parts, parts),
    exhibitions: Object.assign(exhibitions, exhibitions),
    valuations: Object.assign(valuations, valuations),
    images: Object.assign(images, images),
    documents: Object.assign(documents, documents),
}

export default works